import React from "react"
import { Prompt } from "../../../../typings/types"

export interface PromptsTableContextProps {
    selectedPromptUuids: string[]
    setSelectedPromptUuids: (n: string[]) => void
    selectAll: boolean
    setSelectAll: (b: boolean) => void
}

export const PromptsTableContext = React.createContext<PromptsTableContextProps>({
    selectedPromptUuids: [],
    setSelectedPromptUuids: () => {},
    selectAll: false,
    setSelectAll: () => {}
})

interface PromptsTableProviderProps {
    value?: PromptsTableContextProps
    children: React.ReactNode
}

export const PromptsTableProvider: React.FunctionComponent<PromptsTableProviderProps> = props => {
    const [selectedPromptUuids, setSelectedPromptUuids] = React.useState<string[]>([])
    const [selectAll, setSelectAll] = React.useState<boolean>(false)

    const contextValue = React.useMemo(
        () => ({
            selectedPromptUuids,
            setSelectedPromptUuids,
            selectAll,
            setSelectAll
        }),
        [selectAll, setSelectAll, selectedPromptUuids, setSelectedPromptUuids]
    )

    return <PromptsTableContext.Provider value={props.value ?? contextValue} {...props} />
}
